// Hook for GET /projects/:projectId/settings/dashboard

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import type { AxiosResponse } from 'axios';

export type DashboardMember = {
  id: number;
  'first-name': string;
  'last-name': string;
  title: string;
  avatar: string;
  'is-project-lead': boolean;
  'dashboard-reports-visible': boolean;
};

export type DashboardResponse = {
  'looker-reports': any[];
  members: DashboardMember[];
};

export const DASHBOARD_RQ_KEY = 'Dashboard';

const getDashboard = async (projectId: string): Promise<AxiosResponse<DashboardResponse>> => {
  return axios.get(`api/projects/${projectId}/settings/dashboard`);
};

type UseDashboardOptions = {
  config?: UseQueryOptions<AxiosResponse<DashboardResponse>, Error>;
};

export const useGetLookerReports = (projectId: string, options: UseDashboardOptions = {}) => {
  const queryInfo = useQuery<AxiosResponse<DashboardResponse>, Error>(
    [DASHBOARD_RQ_KEY, projectId],
    () => getDashboard(projectId),
    {
      staleTime: Infinity,
      ...(options.config as UseQueryOptions<AxiosResponse<DashboardResponse>, Error>),
    }
  );

  const response = queryInfo.data;
  const data = response;

  return {
    queryInfo,
    data,
    members: data?.['members'],
    lookerReports: data?.['looker-reports'],
  };
};
